// Farm selections and membership lists are server data, not unsynchronised work.
export function isAccountFarmMetadata(key: string, raw: string | null, account: number): boolean {
  if (!["selectedHolding", "userHoldings"].includes(key) || !Number.isSafeInteger(account) || account < 1) return false;
  try {
    const value = JSON.parse(raw);
    return key === "selectedHolding"
      ? value?.user_id === account
      : Array.isArray(value) && value.every(holding => holding?.user_id === account);
  } catch {
    return false;
  }
}
